// extracted by mini-css-extract-plugin
module.exports = {"container":"crm-c_container__2PDxt","content":"crm-c_content__3ohPW","top":"crm-c_top__VinO4"};